import React from 'react';
import { useModal } from '../../hooks/useModal';
import Card from '../cards/card';
import HeaderModal from '../containers/header.modal';
import CreateChannelForm from '../form/forms/create-channel.form';

const styles = {
  container: 'h-full w-full relative',
  header:
    'mobile:px-2 tablet-lg:px-5 py-3 sticky top-0 z-50 bg-[#08080D]/50 backdrop-blur-lg',
  'avatar-wrapper': 'mask h-fit w-fit mask-squircle p-1 bg-[#121212]',
  footer: 'sticky bottom-0 h-7 z-70 bg-[#08080D]',
};

export default function CreateChannelModal() {
  const [_, closeCreateChannelModal] = useModal('CREATE_CHANNEL');
  return (
    <Card className={styles.container}>
      <Card.Header className={styles.header}>
        <HeaderModal
          close={closeCreateChannelModal}
          title="Create Channel"
          button={{ text: 'create', action: closeCreateChannelModal }}
        />
      </Card.Header>
      <Card.Body>
        <CreateChannelForm />
      </Card.Body>
      <Card.Footer className={styles.footer}>
        <div />
      </Card.Footer>
    </Card>
  );
}
